import React from "react";

function Hero() {
  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center px-6"
    >
      <div className="text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight">
          Andreas Wallin
        </h1>
        <p className="mt-4 text-lg md:text-xl text-neutral-400 font-light">
          Software Developer
        </p>
        <div className="mt-10 flex justify-center gap-4">
          <a
            href="#projects"
            className="px-6 py-3 bg-accent text-white text-sm rounded-lg hover:bg-accent-light transition-colors"
          >
            View Work
          </a>
          <a
            href="#about"
            className="px-6 py-3 border border-dark-border text-neutral-300 text-sm rounded-lg hover:border-accent hover:text-white transition-colors"
          >
            About Me
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
